import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const BrandsSubscriptionsOption: LazyOption = createLazyOption(
    {
        key: 'brandsSubscriptionsOption',
        titleStringKey: 'optionTitle_subscriptionActions',
        searchTermsStringKey: 'optionTitle_subscriptionActions',
        hideTitleInFullOptions: true,
        isHidden: () => !isFeatureEnabled('doc-brandsSubscriptions'),
    },
    lazyFullModule,
    m => m.default
);
export default BrandsSubscriptionsOption;
